import { IdentifierDTO } from '@zazume/zzm-base';

export const ContactKeys = {
  base: 'contact',
  requestPropertyManagementCallByUser: (id: IdentifierDTO) =>
    [ContactKeys.base, id]
};
